export const icons = {
  home: 'M4 10.5 12 4l8 6.5V20h-5v-5H9v5H4v-9.5z',
  analysis: 'M5 4h14v3H5V4zm0 6h14v3H5v-3zm0 6h9v3H5v-3z',
  practice: 'M12 2l2.4 5.5L20 8l-4 4 1 6-5-3-5 3 1-6-4-4 5.6-.5L12 2z',
  progress: 'M5 19h14v2H5v-2zm1-3 4-4 3 3 5-7 1.7 1.1-6.4 9-3.2-3.2-2.7 2.7L6 16z',
  account: 'M12 12a4 4 0 100-8 4 4 0 000 8zm-7 8a7 7 0 0114 0H5z',
  report: 'M5 4h14v3H5V4zm0 6h14v3H5v-3zm0 6h9v3H5v-3z',
  diagnosisChip: [
    'M4.5 12h3.3l2.1-6 4.2 12 2.1-6h3.3',
    'M3.75 7.8V5.25H6.3M17.7 5.25h2.55V7.8M20.25 16.2v2.55H17.7M6.3 18.75H3.75V16.2',
  ],
  practiceChip: [
    'M4.5 19.5 19.5 4.5',
    'M12.75 4.5h6.75v6.75',
    'M6 14.25 9.75 18 16.5 11.25',
  ],
  progressChip: [
    'M3.75 18.75h16.5',
    'm5.25 15 4.5-4.5 3.75 3.75 6-7.5',
    'M15.6 6.75h3.9v3.9',
  ],
}

export const navItems = [
  { id: 'home', to: '/home', label: 'Home', match: '/home', icon: icons.home, rail: true, tab: true },
  { id: 'analysis', to: '/analysis', label: 'Reports', match: '/analysis', icon: icons.analysis, rail: true, tab: true },
  { id: 'practice', to: '/practice', label: 'Practice', match: '/practice', icon: icons.practice, rail: true, tab: true },
  { id: 'progress', to: '/progress', label: 'Progress', match: '/progress', icon: icons.progress, rail: true, tab: true },
  { id: 'account', to: '/account', label: 'Account', match: '/account', icon: icons.account, rail: false, tab: true },
]

export const railNavItems = navItems.filter((item) => item.rail)
export const tabNavItems = navItems.filter((item) => item.tab)
export const accountNavItem = navItems.find((item) => item.id === 'account')

export const viewMeta = {
  home: { mobileTitle: 'Home', mobileIcon: icons.home },
  analysis: { mobileTitle: 'Reports', mobileIcon: icons.analysis },
  practice: { mobileTitle: 'Practice', mobileIcon: icons.practice },
  progress: { mobileTitle: 'Progress', mobileIcon: icons.progress },
  account: { mobileTitle: 'Account', mobileIcon: icons.account },
  report: { mobileTitle: 'Report', mobileIcon: icons.report },
  login: { mobileTitle: 'Sign in' },
  authCallback: { mobileTitle: 'Signing in' },
  gate0: { mobileTitle: 'Gate 0' },
  review: { mobileTitle: 'Founder review' },
  notFound: { mobileTitle: 'Not found' },
}

export function routeMeta(id) {
  return viewMeta[id] || viewMeta.notFound
}

export function isNavActive(path, item) {
  return path === item.match || path.startsWith(`${item.match}/`)
}
